module.exports = __webpack_public_path__ + "img/news-1-3.4cac6dde.png";